import { useEffect } from 'react';
import { initLenis } from '../lib/smooth';
import { Hero } from '../components/landing/Hero';
import { Marquee } from '../components/landing/Marquee';
import { AppSection } from '../components/landing/AppSection';
import { TrainingSection } from '../components/landing/TrainingSection';
import { Guarantee } from '../components/landing/Guarantee';
import { Testimonials } from '../components/landing/Testimonials';
import { Benefits } from '../components/landing/Benefits';
import { Pricing } from '../components/landing/Pricing';
import { Footer } from '../components/landing/Footer';
import { StickyCTA } from '../components/landing/StickyCTA';

export default function Landing() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <main className="noise relative bg-[#030303]">
      <Hero />
      <Marquee />
      <AppSection />
      <TrainingSection />
      <Guarantee />
      <Testimonials />
      <Benefits />
      <Pricing />
      <Footer />
      <StickyCTA />
    </main>
  );
}
